import React, { useState } from 'react';
import { FIELD_TYPES, HELPTEXT_TYPES, VALIDATION_RULE } from '../../../libs/formdatavalidator/constants';
import FormDataValidator from '../../../libs/formdatavalidator/FormDataValidator';
import { SYSTEM } from '../../businesslogic/constants/constants';
import Button from '../button/Button';
import { BUTTON_TYPE } from '../button/constants';
import CheckboxWLabel from '../checkbox/checkboxwlabel/CheckboxWLabel';
import SelectDropdown from '../dropdown/selectdropdown/SelectDropdown';
import { VEC_ICON_NAME } from '../icons/constants';
import CalendarInputWDateFormat from '../input/calendarinput/CalendarInputWDateFormat';
import FreeHandDraw from '../input/freehanddraw/FreeHandDraw';
import RadioInput from '../input/radioinput/RadioInput';
import TextAreaForForms from '../input/textarea/TextAreaForForms';
import TextInput from '../input/textinput/TextInput';
import MultiSelectDropdown from '../multiselect/multiselectdropdown/MultiSelectDropdown';
import TxTooltipWIcon from '../tooltip/txtooltipwicon/TxTooltipWIcon';
import styles from './FormInput.styles';
import SelectOptionModal from '../../businesslogic/components/selectoptionmodal/SelectOptionModal';
import Popup from '../popup/Popup';
import { FEATURE_FLAG } from '../../featureFlags';
import Icons from '../icons/Icons';
import DateUtils from '../../../libs/utility/DateUtils';
import FormAttachmentUpload from '../../businesslogic/components/formattachmentupload.js/FormAttachmentUpload';

export default function FormInput({
    id = null,
    type = "text",
    name,
    placeHolder = "",
    fieldObj,
    fieldsArr,
    className = "",
    onChangeCb = () => { },
    customStyles = {},
    onFocusCb = () => { },
    onClickCb = () => { },
    onBlurCb = () => { },
    hideBorder = false,
    prefixProps,
    label="",
    dropdownOnSelectCb=() => {},
    options = [],
    dropdownValue = {label: "select", value: ""},
    formsPreLoadedData = {},
    isIRSViewOn = false,
    disabled,
    dispatchNotificationCb = () => {},
    tabIndex = "0",
    helpIconProps = {},
}) {

    const [openOptionsModal, setOpenOptionsModal] = useState(false)

    const handleOnBlur = (e) => {
        if(type === FIELD_TYPES.DATE){
            fieldObj = {
                ...fieldObj,
                inputValue: e
            }
        }else{
            fieldObj = {
                ...fieldObj,
                inputValue: (type === "checkbox") ? e.target.checked : e.target.value
            }
        }
        
        const validationResult = FormDataValidator.validate(fieldObj, fieldsArr);
        if(isIRSViewOn && validationResult?.isError){
            dispatchNotificationCb(`Error in ${fieldObj.Label}`, validationResult.errorMessage, "DANGER");
        }
        onBlurCb(e, validationResult);
    }

    const handlePaste = (e, type) => {
        let regex;

        switch (type) {
            case FIELD_TYPES.CURRENCY:
                regex = /[eE+-]/
                break;
            default:
                break;
        }

        const pastedText = e.clipboardData.getData('text');

        if (regex && pastedText.match(regex)) {
            e.preventDefault();
        }
    };

    const getInputComponent = (type, fieldObj) => {
        switch(type){
            case FIELD_TYPES.STRING:
            case FIELD_TYPES.CURRENCY:
                return <TextInput
                    id={id}
                    name={name}
                    type={(type === FIELD_TYPES.CURRENCY || VALIDATION_RULE.NUMERIC in fieldObj?.Validations) ? "number" : "text"}
                    onKeyDownCb={(type === FIELD_TYPES.CURRENCY) ? (e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault() : () => { }}
                    placeholder={placeHolder}
                    onChangeCb={e => type === FIELD_TYPES.CURRENCY ? !(e.target.value < 0) && onChangeCb(e) : onChangeCb(e) }
                    customStyles={{ ...styles.textInput, ...customStyles, ...(disabled ? styles.disabledInput : {}) }}
                    className={className}
                    value={fieldObj?.inputValue ? fieldObj.inputValue : ""}
                    onFocus={onFocusCb}
                    onClickCb={onClickCb}
                    onBlurCb={e => handleOnBlur(e)}
                    prefixProps={prefixProps}
                    hideBorder={hideBorder}
                    errors={(fieldObj?.validationResult?.isError && isIRSViewOn) ? {error: true} : {}}
                    disabled={disabled}
                    onPasteCb={(e) => handlePaste(e,type)}
                    tabIndex={tabIndex}
                />
            case FIELD_TYPES.BOOLEAN:
                return <CheckboxWLabel
                    label={
                        isIRSViewOn && !fieldObj?.IRSLayout?.displayLabel
                        ? null 
                        : ('GroupLabel' in fieldObj && fieldObj?.GroupLabel
                        ? fieldObj.Label
                        : (fieldObj?.BoxInfo?.Box
                        ? `${fieldObj.BoxInfo.Box}. ${fieldObj.Label}`
                        : fieldObj.Label))
                    }
                    appendRequiredStar={fieldObj?.Validations?.Required?.Value ? true : false}
                    checked={(fieldObj.inputValue === "true" || fieldObj.inputValue === true)} 
                    onChangeCb={e => onChangeCb(e)}
                    labelCustomStyles={customStyles}
                    disabled={disabled}
                    name={name}
                    tabIndex={tabIndex}
                />
            case FIELD_TYPES.ENUM:
                return <SelectDropdown
                    label={label}
                    placeHolder={placeHolder}
                    name={name}
                    value={dropdownValue}
                    onSelectCb={dropdownOnSelectCb}
                    options={options}
                    disabled={disabled}
                    tabIndex={tabIndex}
                />
            case FIELD_TYPES.MULTISELECTENUM:
                return <MultiSelectDropdown 
                    options={options}
                    maxSelection={fieldObj?.MaxSelectionLength ?? null}
                    onSelectOptionsCb={(newOptions) => dropdownOnSelectCb(name, newOptions)}
                    tabIndex={tabIndex}
                    dropdownSingleOptionContainerCustomStyles={styles.multiSelectEnumSingleOptionCustomStyles}
                    disabled={disabled}
                />
            case FIELD_TYPES.DATE:
                return <CalendarInputWDateFormat
                name={`date_${fieldObj.Name}`}
                value={fieldObj?.inputValue ? fieldObj.inputValue : ""}
                onChangeCb={e => onChangeCb(e)}
                onBlurCb={e => handleOnBlur(e)}
                dateFormat={SYSTEM.DATE_FORMAT}
                disabled={disabled}
                tabIndex={tabIndex}
                maxAllowedDate={fieldObj?.DateProperty?.maxAllowedDate ? DateUtils.getMomentObject(fieldObj?.DateProperty?.maxAllowedDate) : null}
                minAllowedDate={fieldObj?.DateProperty?.minAllowedDate ? DateUtils.getMomentObject(fieldObj?.DateProperty?.minAllowedDate) : null}
                showMonthDropdown={fieldObj?.DateProperty?.showMonthDropdown ?? true}
                showYearDropdown={fieldObj?.DateProperty?.showYearDropdown ?? true}
            />
            case FIELD_TYPES.TEXTAREA:
                return <TextAreaForForms
                value={fieldObj?.inputValue ? fieldObj.inputValue : ""} 
                onChangeCb={(e) => onChangeCb(e)} 
                rows={3}
                onBlurCb={e => handleOnBlur(e)}
                maxCharacterCount={fieldObj?.Validations?.StringLength?.Maximum ?? 40}
                disabled={disabled}
                tabIndex={tabIndex}
            />
            case FIELD_TYPES.RADIO:
                return renderRadioComponent(options, fieldObj, disabled);
            case FIELD_TYPES.FREEHANDDRAW:
                return <FreeHandDraw
                onStrokeEndCb={e => onChangeCb(e)}
                onClearCb={e => onChangeCb(e)}
                freeHandDrawnDataURL={fieldObj?.inputValue ? "data:image/png;base64," + fieldObj?.inputValue : ""}
            />
            case FIELD_TYPES.BUTTON:
                return <Button type={BUTTON_TYPE.PRIMARY} onClickCb={e => onChangeCb(e)} >
                    {fieldObj?.Label}
                </Button>
            case FIELD_TYPES.ENUM_MODAL:
                if (!FEATURE_FLAG.ALLOW_ENUM_DROPDOWN) {
                    return <SelectDropdown
                        label={label}
                        placeHolder={placeHolder}
                        name={name}
                        value={dropdownValue}
                        onSelectCb={dropdownOnSelectCb}
                        options={options}
                        disabled={disabled}
                        tabIndex={tabIndex}
                    />
                } else {
                    return <TextInput
                        label={label}
                        placeHolder={placeHolder}
                        name={name}
                        value={dropdownValue.label}
                        onClickCb={() => {
                            setOpenOptionsModal(true)
                        }}
                        tabIndex={tabIndex}
                        disabled={disabled}
                    />
                }
            case FIELD_TYPES.FILE_UPLOAD:
                return <FormAttachmentUpload 
                    onChangeCb={onChangeCb} 
                    name={name} 
                    value={fieldObj?.inputValue ?? ""} 
                    disabled={disabled}
                />
        }
    }

    const renderHelpTextComponent = (type, fieldObj) => {
        switch(type){
            case HELPTEXT_TYPES.IFRAME:
                return <span style={styles.helpTextIconStyle} onClick={() => helpIconProps?.onClickCb(fieldObj?.HelpText)}><Icons iconName={VEC_ICON_NAME.HELP_INFO_ICON} familyName="vec" transformScale={0.75} /></span>
            case HELPTEXT_TYPES.TOOLTIP:
                return <span style={styles.helpTextIconStyle} ><TxTooltipWIcon
                            id={fieldObj?.Name}
                            text={fieldObj?.HelpText?.Value}
                            iconName={VEC_ICON_NAME.HELP_INFO_ICON}
                        /></span>
        }
    }

    const renderRadioComponent = (radioOptions, mainField, disabled) => {
        const renderedRadioInput = [];
        radioOptions.forEach((option, index) => {
            renderedRadioInput.push(
                <RadioInput
                    label={
                        { suffixLabel: option.Label}
                    }
                    value={option.Key}
                    name={mainField.Name}
                    checked={mainField?.inputValue == option.Key}
                    onChangeCb={e => onChangeCb(e)}
                    disabled={(disabled || option?.isReadonly) ? true : false }
                    tabIndex={tabIndex}
                />
            );
        });
        return renderedRadioInput;
    }

    return <>
        {
            <div style={styles.formFieldWrapper}>
                <div style={styles.formField}>
                    {getInputComponent(type, fieldObj)}
                </div>
                { 
                    fieldObj?.HelpText && fieldObj?.HelpText?.Type && renderHelpTextComponent(fieldObj?.HelpText?.Type, fieldObj)
                }
            </div>
        }
        {
            (isIRSViewOn && fieldObj?.validationResult?.isError) ? <span>
                <TxTooltipWIcon
                    id={`error_${fieldObj.Name}`}
                    text={fieldObj?.validationResult?.errorMessage}
                    iconName={VEC_ICON_NAME.ERROR_ICON}
                    customTooltipstyles={styles.errorTooltip}
                />
            </span>
        : <span style={styles.errorText}>{fieldObj?.validationResult?.errorMessage}</span>
        }
        {openOptionsModal &&
            <Popup onCloseCb={() => { setOpenOptionsModal(false) }} title={fieldObj.Label} isPopupOpen={openOptionsModal}
                customPopupSyles={styles.optionsModalCustomPopup}
                overlayStyles={styles.optionsModalOverlayStyles}
                childrenStyles={styles.optionsModalChildrenStyles}
            >
                <SelectOptionModal options={options} selectedOption={dropdownValue} onSelectCb={(selectedOption) => dropdownOnSelectCb(name, selectedOption)} />
            </Popup>
        }
    </>
}